import { render, staticRenderFns } from "./Services.vue?vue&type=template&id=729e8243&scoped=true"
var script = {}
import style0 from "./Services.vue?vue&type=style&index=0&id=729e8243&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729e8243",
  null
  
)

export default component.exports